/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_PhotographyInputs */

const en_gallery_category_photography = /** @type {(inputs: Gallery_Category_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photography`)
};

const es_gallery_category_photography = /** @type {(inputs: Gallery_Category_PhotographyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia`)
};

/**
* | output |
* | --- |
* | "Photography" |
*
* @param {Gallery_Category_PhotographyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_photography = /** @type {((inputs?: Gallery_Category_PhotographyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_PhotographyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_photography(inputs)
	return es_gallery_category_photography(inputs)
});